import { render, staticRenderFns } from "./ProcessGroups.vue?vue&type=template&id=f8adefee&"
import script from "./ProcessGroups.vue?vue&type=script&lang=js&"
export * from "./ProcessGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports